import { Custom_Preset } from '@bo-ibSheet/common';

export const userGridOptions = {
  LeftCols: [Custom_Preset.RowIndex],
  Cols: [
    {
      ...Custom_Preset.UserId,
      Header: '사용자ID',
      Name: 'userId',
      Key: 'user_id',
    },
    {
      ...Custom_Preset.UserName,
      Header: '사용자명',
      Name: 'userName',
      Key: 'user_nm',
    },
    {
      Header: '사용자권한명',
      Type: 'Text',
      Name: 'jobGroupName',
      Key: 'job_grp_nm',
      MinWidth: 180,
      Width: 180,
      Align: 'Center',
      Size: 13,
      CanEdit: false,
    },
    {
      Header: '사용상태',
      Type: 'Enum',
      Name: 'useYn',
      Key: 'use_yn',
      MinWidth: 120,
      Width: 120,
      Enum: '|사용|미사용',
      EnumKeys: '|Y|N',
      Align: 'Center',
      Size: 13,
      CanEdit: false,
    },
    {
      Header: '시작일',
      Type: 'Date',
      Name: 'useStartDate',
      Key: 'use_start_date',
      MinWidth: 185,
      Width: 185,
      Align: 'Center',
      Size: 13,
      CanEdit: false,
      DataFormat: 'yyyyMMddHHmmss',
      Format: 'yyyy-MM-dd',
    },
    {
      Header: '종료일',
      Type: 'Date',
      Name: 'useEndDate',
      Key: 'use_end_date',
      MinWidth: 185,
      Width: 185,
      Align: 'Center',
      Size: 13,
      CanEdit: false,
      DataFormat: 'yyyyMMddHHmmss',
      Format: 'yyyy-MM-dd',
    },
  ],
};
